import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { BookOpen } from 'lucide-react';
const chapters = [{
  number: 1,
  title: 'Cómo reconocer tu dolor sin que te destruya — y por qué sentirlo es el primer acto de valentía'
}, {
  number: 2,
  title: "El poder del 'Yo Soy': las dos palabras que están construyendo o destruyendo tu vida cada día"
}, {
  number: 3,
  title: 'Cuando Dios entra en la herida: por qué la fe no es debilidad sino la única fuerza que llega donde el esfuerzo no puede'
}, {
  number: 4,
  title: 'Cómo reconstruirte sin prisa pero sin pausa — incluyendo el Plan de 12 Semanas paso a paso'
}, {
  number: 5,
  title: 'Sanar relaciones sin romperte a ti mismo en el intento — límites, perdón y cierre de ciclos'
}, {
  number: 6,
  title: "Cómo convertir tu dolor en propósito: el ejercicio 'Mi Testimonio en 3 Actos'"
}];
export function ChaptersSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-[var(--midnight)] py-24 md:py-32" data-id="element-87">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.8
    }} className="max-w-5xl mx-auto px-6" data-id="element-88">
        <div className="space-y-12" data-id="element-89">
          <h2 className="font-display text-4xl md:text-5xl text-[var(--warm-gold)] text-center" data-id="element-90">
            Lo Que Vas a Descubrir
          </h2>

          <div className="space-y-6" data-id="element-91">
            {chapters.map((chapter, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -30
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex gap-6 items-start bg-[var(--dusk-purple)]/20 p-6 rounded-xl border-l-4 border-[var(--warm-gold)]" data-id="element-92">
                <div className="flex-shrink-0" data-id="element-93">
                  <div className="w-12 h-12 bg-[var(--warm-gold)] rounded-full flex items-center justify-center" data-id="element-94">
                    <span className="font-display text-xl font-bold text-[var(--midnight)]" data-id="element-95">
                      {chapter.number}
                    </span>
                  </div>
                </div>
                <p className="text-[var(--cream)] text-lg leading-relaxed pt-2" data-id="element-96">
                  {chapter.title}
                </p>
              </motion.div>)}

            {/* Chapters 7-11 consolidated */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            duration: 0.5,
            delay: 0.7
          }} className="flex gap-6 items-start bg-[var(--dusk-purple)]/20 p-6 rounded-xl border-l-4 border-[var(--warm-gold)]" data-id="element-97">
              <div className="flex-shrink-0" data-id="element-98">
                <BookOpen className="w-12 h-12 text-[var(--warm-gold)]" data-id="element-99" />
              </div>
              <p className="text-[var(--cream)] text-lg leading-relaxed pt-2" data-id="element-100">
                <strong data-id="element-101">Capítulos 7-11:</strong> Reconstruir una vida con
                sentido, vivir con propósito y fe, compartir tu historia y el
                Decálogo del Renacido
              </p>
            </motion.div>
          </div>
        </div>
      </motion.div>
    </section>;
}